var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.contentTxt,
            expression: "contentTxt"
          }
        ],
        attrs: { id: _vm.contentId },
        domProps: { value: _vm.contentTxt },
        on: {
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.contentTxt = $event.target.value
          }
        }
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "", persistent: "", "max-width": "320" },
          model: {
            value: _vm.dialogEmoji,
            callback: function($$v) {
              _vm.dialogEmoji = $$v
            },
            expression: "dialogEmoji"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "primary white--text" }, [
                _c(
                  "div",
                  { staticClass: "title" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "" },
                        on: {
                          click: function($event) {
                            _vm.dialogEmoji = false
                          }
                        }
                      },
                      [
                        _c("v-icon", { staticClass: "white--text" }, [
                          _vm._v("close")
                        ])
                      ],
                      1
                    ),
                    _vm._v("\n            emoji\n          ")
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c("Picker", {
                    attrs: {
                      data: _vm.emojiIndex,
                      native: "",
                      perLine: 8,
                      sheetSize: 18,
                      emojiSize: 20,
                      showSearch: true,
                      showPreview: false,
                      showSkinTones: true,
                      showCategories: true,
                      color: _vm.$vuetify.theme.secondary,
                      i18n: _vm.i18nPicker
                    },
                    on: { select: _vm.addEmoji }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.dialogEmoji = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e904270e", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e904270e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzTxtEditor.vue
// module id = null
// module chunks = 